import { Style } from "@portal/lib/style/style";
import { Card } from "../Card/AntCard";

export const StyledTile = Style(Card, {
  borderRadius: "var(--br-1)",
  position: "relative",
  border: 0,
  height: "100%",

  ".ant-card-body": {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  variants: {
    size: {
      lg: {
        ".ant-card-body": {
          minWidth: "270px",
          padding:
            "var(--space-20) var(--space-40) var(--space-16) var(--space-24)!important",
        },
      },
      md: {
        ".ant-card-body": {
          padding:
            "var(--space-12) var(--space-20) var(--space-16) var(--space-16)!important",
        },
        minWidth: "234px",
      },
      sm: {
        ".ant-card-body": {
          padding:
            "var(--space-20) var(--space-24) 14px var(--space-24)!important",
        },
        minWidth: "200px",
      },
    },

    layout: {
      l1: {
        ".ant-card-body": {
          height: "100%",
          display: "flex",
          justifyContent: "start",
          alignItems: "start",
        },
      },
    },

    bottomStrip: {
      strip: {
        "&::after": {
          width: "100%",
          height: "4px",
          background: "var(--stripColor)",
          content: "",
          position: "absolute",
          bottom: 0,
          borderBottomLeftRadius: "var(--br-1)",
          borderBottomRightRadius: "var(--br-1)",
        },
      },
    },
  },
});
